export const PROTEINS = [
  { name: "Chicken breast", grams: 8.6 },
  { name: "Turkey breast", grams: 7.5 },
  { name: "Chicken thighs", grams: 7.5 },
  { name: "Chicken drumsticks", grams: 7.5 },
  { name: "Ground turkey", grams: 6.0 },
  { name: "Chicken sausage", grams: 5.0 },
  { name: "Turkey sausage", grams: 5.0 },
  { name: "Egg", grams: 6.0 },
  { name: "Beef brisket", grams: 10.0 },
  { name: "Ground beef (93% lean)", grams: 7.5 },
  { name: "Top sirloin", grams: 7.5 },
  { name: "Ground bison", grams: 7.5 },
  { name: "Ground buffalo", grams: 7.5 },
  { name: "Flank steak", grams: 7.5 },
  { name: "Ground venison", grams: 7.5 },
  { name: "Ground lamb", grams: 6.0 },
  { name: "Lamb chops", grams: 5.0 },
  { name: "Sardines (canned)", grams: 7.5 },
  { name: "Tilapia (cooked)", grams: 7.5 },
  { name: "Salmon (cooked)", grams: 6.0 },
  { name: "Trout (cooked)", grams: 6.0 },
  { name: "Cod (cooked)", grams: 5.0 },
  { name: "Mackerel (cooked)", grams: 5.0 },
  { name: "Herring (cooked)", grams: 5.0 },
  { name: "Shrimp (sautéed)", grams: 5.0 },
  { name: "Lupini beans (cooked)", grams: 3.0 },
  { name: "Tempeh", grams: 5.0 },
  { name: "Tofu (firm)", grams: 3.3 },
  { name: "Lentils (cooked)", grams: 2.6 },
  { name: "Black beans (cooked)", grams: 3.8 },
  { name: "Navy beans (cooked)", grams: 3.8 },
  { name: "Chickpeas (cooked)", grams: 3.7 },
  { name: "Mung beans (cooked)", grams: 2.0 },
  { name: "Quinoa (cooked)", grams: 1.5 },
  { name: "Peas (cooked)", grams: 1.5 },
  { name: "Peanuts", grams: 7.3 },
  { name: "Almonds", grams: 6.0 },
  { name: "Pistachios", grams: 5.7 },
  { name: "Cashews", grams: 5.2 },
  { name: "Walnuts", grams: 4.3 },
  { name: "Hazelnuts", grams: 4.3 },
  { name: "Brazil nuts", grams: 4.0 },
  { name: "Pine nuts", grams: 3.9 },
  { name: "Pecans", grams: 2.6 },
  { name: "Macadamia nuts", grams: 2.2 },
  { name: "Whey protein isolate", grams: 25.0 },
  { name: "Pea protein", grams: 24.0 },
  { name: "Hemp protein", grams: 15.0 },
  { name: "Bone broth protein isolate", grams: 20.0 },
];
